<template>
  <div class="tab">
    <div>
      <span @click="returnFun()">＜返回</span>
      <p style="font-size: 14px;text-align: right;color:#777">誉蓉 学业坚韧性项目组 2017-08-07</p>
      <div class="rich_media_content" style="max-width: 677px;margin: auto;">
        <section style="box-sizing: border-box;">
          <section class style="   box-sizing: border-box; " powered-by="xiumi.us">
            <section
              class
              style=" margin-top: 10px; margin-bottom: 10px;  box-sizing: border-box; "
            >
              <section
                class
                style="width: 6px; height: 6px; margin-top: 0.5em; margin-right: 0.4em; margin-left: 0.4em; border-radius: 100%; background-color: rgb(95, 156, 239); box-sizing: border-box;"
              ></section>
              <section
                class
                style="height: 3em; border-left: 1px solid rgb(158, 158, 158); margin-bottom: -2.4em; margin-left: 0.6em; box-sizing: border-box;"
              ></section>
              <section
                class
                style="width: 5em; border-top: 1px solid rgb(158, 158, 158); box-sizing: border-box;"
              ></section>
              <section
                class
                style="padding-right: 0.5em; padding-left: 0.5em; box-sizing: border-box;"
              >
                <section class style="padding: 10px; box-sizing: border-box;">
                  <section class style="box-sizing: border-box;" powered-by="xiumi.us">
                    <section class style="   box-sizing: border-box; ">
                      <section
                        class
                        style="text-align: justify; font-size: 14px; box-sizing: border-box;"
                      >
                        <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                          斯坦福大学的Dweck教授等一直以来致力于学生的“成长型思维”的研究，通过一系列研究，她们发现，
                          <strong
                            style="box-sizing: border-box;"
                          >相信自己智力可以不断发展的学生，总体表现要优于他们身边那些认为智力一成不变的同伴。</strong>这样认为自己的智力可以提升的信念是成长型思维的体现。
                        </p>
                        <p style="white-space: normal; box-sizing: border-box;">
                          <br style="box-sizing: border-box;" />
                        </p>
                        <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                          很多人可能对成长型思维的概念并不陌生
                          ，也有一大批老师和家长愿意尝试应用这样的成长型思维原则来指导自己对学生的教育。然而在实际
                          活中真正操练起来却也绝非易事，若是不加以甄别，容易走进陷阱，效果适得其反。
                        </p>
                        <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                          <br style="box-sizing: border-box;" />
                        </p>
                      </section>
                    </section>
                  </section>
                </section>
              </section>
              <section class style="width: 5em; margin-left: auto; box-sizing: border-box;">
                <section
                  style="width: 5em; border-top: 1px solid rgb(158, 158, 158); box-sizing: border-box;"
                ></section>
                <section
                  style="height: 3em; border-left: 1px solid rgb(158, 158, 158); margin-top: -2.4em; margin-left: 4.4em; box-sizing: border-box;"
                ></section>
                <section
                  style="width: 6px; height: 6px; margin-left: auto; margin-right: 0.4em; border-radius: 100%; background-color: rgb(95, 156, 239); box-sizing: border-box;"
                ></section>
              </section>
            </section>
          </section>
          <section class style="   box-sizing: border-box; " powered-by="xiumi.us">
            <section
              class
              style=" text-align: center; margin-top: 10px; margin-bottom: 10px;  box-sizing: border-box; "
            >
              <img
                style="vertical-align: middle; box-sizing: border-box; width: 640px !important; height: auto !important; visibility: visible !important;"
                data-ratio="1"
                data-w="640"
                _width="640px"
                src="../../assets/growthThinking/list4/640(1).png"
                crossorigin="anonymous"
                data-fail="0"
              />
            </section>
          </section>
          <section class style="   box-sizing: border-box; " powered-by="xiumi.us">
            <section
              class
              style=" margin-top: 10px; margin-bottom: 10px; text-align: center;  box-sizing: border-box; "
            >
              <section
                class
                style="display: inline-block; vertical-align: middle; box-sizing: border-box;"
              >
                <section
                  class
                  style="display: inline-block; vertical-align: bottom; padding-left: 5px; padding-right: 5px; line-height: 1.2em; margin-bottom: 2px; box-sizing: border-box;"
                >
                  <p style="box-sizing: border-box;">
                    <strong style="box-sizing: border-box;">
                      常见误区1:建立成长型思维≠追捧努力
                      &nbsp;
                    </strong>
                  </p>
                </section>
                <img
                  style="display: inline-block; vertical-align: bottom; box-sizing: border-box; width: 1.6em !important; height: 1.875em !important;"
                  data-ratio="1.171875"
                  data-w="128"
                  width="1.6em"
                  data-type="png"
                  _width="1.6em"
                  src="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg=="
                  crossorigin="anonymous"
                />
              </section>
            </section>
          </section>
          <section class style="   box-sizing: border-box; " powered-by="xiumi.us">
            <section
              class
              style=" margin-top: 10px; margin-bottom: 10px;  box-sizing: border-box; "
            >
              <section class style="margin-bottom: -12px; box-sizing: border-box;">
                <section style="float: left; margin-left: 20%; box-sizing: border-box;">
                  <section
                    style="width: 2px; height: 0.8em; background-color: rgb(17, 19, 22); box-sizing: border-box;"
                  ></section>
                  <section
                    style="width: 6px; height: 6px; background: rgb(17, 19, 22); margin-left: -2px; border-radius: 50%; box-sizing: border-box;"
                  ></section>
                </section>
                <section style="float: right; margin-right: 20%; box-sizing: border-box;">
                  <section
                    style="width: 2px; height: 0.8em; background-color: rgb(17, 19, 22); box-sizing: border-box;"
                  ></section>
                  <section
                    style="width: 6px; height: 6px; background: rgb(17, 19, 22); margin-left: -2px; border-radius: 50%; box-sizing: border-box;"
                  ></section>
                </section>
                <section style="clear: both; box-sizing: border-box;"></section>
              </section>
              <section class style="padding-right: 8px; padding-top: 8px; box-sizing: border-box;">
                <section
                  style="padding-bottom: 5px; border-width: 1px; border-style: solid; border-color: rgb(255, 222, 3); background-color: rgb(255, 222, 3); box-sizing: border-box;"
                >
                  <section
                    class
                    style="background-color: rgb(214, 240, 252); margin-top: -7px; margin-right: -7px; margin-left: 5px; padding: 10px; box-sizing: border-box;"
                  >
                    <section class style="box-sizing: border-box;" powered-by="xiumi.us">
                      <section class style="   box-sizing: border-box; ">
                        <section
                          class
                          style="text-align: justify; font-size: 14px; box-sizing: border-box;"
                        >
                          <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                            <span style="color: rgb(23, 52, 231); box-sizing: border-box;">
                              <strong style="box-sizing: border-box;">
                                <br style="box-sizing: border-box;" />
                              </strong>
                            </span>
                          </p>
                          <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                            <span style="color: rgb(23, 52, 231); box-sizing: border-box;">
                              <strong style="box-sizing: border-box;">
                                错误对话:
                                只要你努力就一定能行。
                              </strong>
                            </span>
                          </p>
                          <p style="white-space: normal; box-sizing: border-box;">
                            <br style="box-sizing: border-box;" />
                          </p>
                          <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                            这个常见的思维误区就是简单地将成长型思维和努力等同起来。对于学生而言，如果想要进步，那么纯粹强调努力是收效甚微的，
                            <strong style="box-sizing: border-box;">因为努力是完成学习过程的手段，而不能替代学习本身。</strong>学习需要尝试新方法，需要在陷入困境的时候寻求他人的帮助。
                            <br style="box-sizing: border-box;" />
                          </p>
                          <p style="white-space: normal; box-sizing: border-box;">
                            <br style="box-sizing: border-box;" />
                          </p>
                          <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                            作为学生学习过程的引领者，老师和家长应该注意表扬的真正目的所在。表扬的目的不是让学生在当下自我感觉良好，是让他们在一段时间内都有
                            够的能够去迎接未来挑战，去经受住可能有的挫败经历。
                            <br style="box-sizing: border-box;" />
                          </p>
                          <p style="white-space: normal; box-sizing: border-box;">
                            <br style="box-sizing: border-box;" />
                          </p>
                          <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                            当学生暂时陷入困境时， 师和家长可以对学 之前的努力给予肯定，
                            <strong style="box-sizing: border-box;">但一定不要仅仅停留在安慰甚至讨好的层面上，</strong>还应该带领学生审视过去，弄明白之前尝试过什么，之后还需要做什么。这样才
                            会陷入“盲目努力 ，自我感动”的陷阱。&nbsp;
                          </p>
                        </section>
                      </section>
                    </section>
                  </section>
                </section>
              </section>
            </section>
          </section>
          <section class style="   box-sizing: border-box; " powered-by="xiumi.us">
            <section
              class
              style=" margin-top: 10px; margin-bottom: 10px; text-align: center;  box-sizing: border-box; "
            >
              <section
                class
                style="display: inline-block; vertical-align: middle; box-sizing: border-box;"
              >
                <p>
                  <br />
                </p>
                <p>
                  <img
                    style="display: inline-block; vertical-align: bottom; box-sizing: border-box; width: 1.6em !important; height: 2.06897em !important;"
                    data-ratio="1.2931034"
                    data-w="116"
                    width="1.6em"
                    _width="1.6em"
                    src="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg=="
                    crossorigin="anonymous"
                  />
                </p>
                <section
                  class
                  style="display: inline-block; vertical-align: bottom; padding-left: 5px; padding-right: 5px; line-height: 1.2em; margin-bottom: 2px; box-sizing: border-box;"
                >
                  <p style="box-sizing: border-box;">
                    <strong style="box-sizing: border-box;">常见误区2:建立成长型思维≠否认差距&nbsp;</strong>
                  </p>
                </section>
                <br />
              </section>
            </section>
          </section>
          <section class style="   box-sizing: border-box; " powered-by="xiumi.us">
            <section
              class
              style=" margin-top: 10px; margin-bottom: 10px;  box-sizing: border-box; "
            >
              <section class style="margin-bottom: -12px; box-sizing: border-box;">
                <section style="float: left; margin-left: 20%; box-sizing: border-box;">
                  <section
                    style="width: 2px; height: 0.8em; background-color: rgb(17, 19, 22); box-sizing: border-box;"
                  ></section>
                  <section
                    style="width: 6px; height: 6px; background: rgb(17, 19, 22); margin-left: -2px; border-radius: 50%; box-sizing: border-box;"
                  ></section>
                </section>
                <section style="float: right; margin-right: 20%; box-sizing: border-box;">
                  <section
                    style="width: 2px; height: 0.8em; background-color: rgb(17, 19, 22); box-sizing: border-box;"
                  ></section>
                  <section
                    style="width: 6px; height: 6px; background: rgb(17, 19, 22); margin-left: -2px; border-radius: 50%; box-sizing: border-box;"
                  ></section>
                </section>
                <section style="clear: both; box-sizing: border-box;"></section>
              </section>
              <section class style="padding-left: 8px; padding-top: 8px; box-sizing: border-box;">
                <section
                  style="padding-bottom: 5px; border-width: 1px; border-style: solid; border-color: rgb(214, 240, 252); background-color: rgb(214, 240, 252); box-sizing: border-box;"
                >
                  <section
                    class
                    style="background-color: rgb(255, 222, 3); margin-top: -8px; margin-right: 5px; margin-left: -5px; padding: 10px; box-sizing: border-box;"
                  >
                    <section class style="box-sizing: border-box;" powered-by="xiumi.us">
                      <section class style="   box-sizing: border-box; ">
                        <section
                          class
                          style="text-align: justify; font-size: 14px; box-sizing: border-box;"
                        >
                          <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                            <span style="color: rgb(23, 52, 231); box-sizing: border-box;">
                              <strong style="box-sizing: border-box;">
                                <br style="box-sizing: border-box;" />
                              </strong>
                            </span>
                          </p>
                          <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                            <span style="color: rgb(23, 52, 231); box-sizing: border-box;">
                              <strong style="box-sizing: border-box;">错误对话:你永远最棒!你是最聪明的!</strong>
                            </span>
                          </p>
                          <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                            <span style="color: rgb(23, 52, 231); box-sizing: border-box;">
                              <strong style="box-sizing: border-box;">
                                <br style="box-sizing: border-box;" />
                              </strong>
                            </span>
                          </p>
                          <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                            上世纪曾经风行美国的“自尊运动”，后来却被认为是造成学生规模低自尊的原因。
                            <strong style="box-sizing: border-box;">
                              自尊无法通过
                              &nbsp;廉价的表扬和廉价的“成功”来获得。
                            </strong>学生需要通过战胜困难得到征服感，感到自身价值之所在，从而提升尊。
                          </p>
                          <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                            <br style="box-sizing: border-box;" />
                          </p>
                          <p style="text-indent: 2em; white-space: normal; box-sizing: border-box;">
                            建立成长型思维的目的在于帮助学生缩小差距，而非隐藏差距。廉价的表扬只能歪曲事实，甚至影响学生的自我认知以及对现实的准确判断。老师和家长应该做的，
                            <strong style="box-sizing: border-box;">是告诉学生真实的现状，然后，帮助他们变得更好。</strong>
                          </p>
                        </section>
                      </section>
                    </section>
                  </section>
                </section>
              </section>
            </section>
          </section>
          <section class style="   box-sizing: border-box; " powered-by="xiumi.us">
            <p
              style=" text-align: center; margin-top: 10px; margin-bottom: 10px;  box-sizing: border-box; "
            >
              <br />
            </p>
          </section>
          <section class style="   box-sizing: border-box; " powered-by="xiumi.us">
            <section
              class
              style=" margin-top: 10px; margin-bottom: 10px; text-align: center;  box-sizing: border-box; "
            >
              <section
                class
                style="display: inline-block; vertical-align: middle; box-sizing: border-box;"
              >
                <img
                  style="display: inline-block; vertical-align: bottom; box-sizing: border-box; width: 1.6em !important; height: 1.6em !important;"
                  data-ratio="1"
                  data-w="150"
                  width="1.6em"
                  _width="1.6em"
                  src="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg=="
                  crossorigin="anonymous"
                />
                <section
                  class
                  style="display: inline-block; vertical-align: bottom; padding-left: 5px; padding-right: 5px; line-height: 1.2em; margin-bottom: 2px; box-sizing: border-box;"
                >
                  <p style="box-sizing: border-box;">
                    <strong style="box-sizing: border-box;">常见误区3:建立成长型思维≠妖魔化固定型思维&nbsp;</strong>
                  </p>
                </section>
              </section>
            </section>
          </section>
          <section class style="   box-sizing: border-box; " powered-by="xiumi.us">
            <section
              class
              style=" margin-top: 10px; margin-bottom: 10px;  box-sizing: border-box; "
            >
              <section class style="margin-bottom: -12px; box-sizing: border-box;">
                <section style="float: left; margin-left: 20%; box-sizing: border-box;">
                  <section
                    style="width: 2px; height: 0.8em; background-color: rgb(17, 19, 22); box-sizing: border-box;"
                  ></section>
                  <section
                    style="width: 6px; height: 6px; background: rgb(17, 19, 22); margin-left: -2px; border-radius: 50%; box-sizing: border-box;"
                  ></section>
                </section>
                <section style="float: right; margin-right: 20%; box-sizing: border-box;">
                  <section
                    style="width: 2px; height: 0.8em; background-color: rgb(17, 19, 22); box-sizing: border-box;"
                  ></section>
                  <section
                    style="width: 6px; height: 6px; background: rgb(17, 19, 22); margin-left: -2px; border-radius: 50%; box-sizing: border-box;"
                  ></section>
                </section>
                <section style="clear: both; box-sizing: border-box;"></section>
              </section>
              <section class style="padding-right: 8px; padding-top: 8px; box-sizing: border-box;">
                <section
                  style="padding-bottom: 5px; border-width: 1px; border-style: solid; border-color: rgb(255, 222, 3); background-color: rgb(255, 222, 3); box-sizing: border-box;"
                >
                  <section
                    class
                    style="background-color: rgb(214, 240, 252); margin-top: -7px; margin-right: -7px; margin-left: 5px; padding: 10px; box-sizing: border-box;"
                  >
                    <section class style="box-sizing: border-box;" powered-by="xiumi.us">
                      <section class style="   box-sizing: border-box; ">
                        <section class style="font-size: 14px; box-sizing: border-box;">
                          <p style="text-indent: 2em; box-sizing: border-box;">
                            <br style="box-sizing: border-box;" />
                          </p>
                          <p style="text-indent: 2em; box-sizing: border-box;">
                            <span style="color: rgb(23, 52, 231); box-sizing: border-box;">
                              <strong style="box-sizing: border-box;">错误对话:你失败的原因是你没有成长型思维。</strong>
                            </span>
                          </p>
                          <p style="text-indent: 2em; box-sizing: border-box;">
                            <br style="box-sizing: border-box;" />
                          </p>
                          <p style="text-indent: 2em; box-sizing: border-box;">
                            随着成长型思维概念的深入人心，越来越多的
                            师和家长会主动学习相关知识来指导自己的行为，甚至会在学生面前直接提起成长型思维。但是最后学生的表现却并无改观。其中一个非常重要的原因就是，老师和家长可能在有意无意间将所谓的“固定型思维”妖魔化，并由此衍生出对学生的一系列批评。
                            <strong
                              style="box-sizing: border-box;"
                            >用“成长型思维”去判定一个学生，这样的盖章认证，甚至问责和指责，是难以对学生有任何正面影响的。</strong>
                          </p>
                          <p style="text-indent: 2em; box-sizing: border-box;">
                            <br style="box-sizing: border-box;" />
                          </p>
                          <p style="text-indent: 2em; box-sizing: border-box;">
                            成长型思维的建立是一个漫长的，甚至可能永 &nbsp;无目的地的旅程，而不是是一个机械的布告。那么
                            作为一个教育工作者应当如何真正有效地帮助学生建立成长型思维呢?Dweck 教授给出了她的答案:
                          </p>
                          <p style="text-indent: 2em; box-sizing: border-box;">
                            <strong style="box-sizing: border-box;">将固定型思维合理化。</strong>
                          </p>
                          <p style="text-indent: 2em; box-sizing: border-box;">
                            <br style="box-sizing: border-box;" />
                          </p>
                          <p style="text-indent: 2em; box-sizing: border-box;">
                            “纯正”的成长型思维或者固定型思维是不存在的，我们每个人拥有的都是二者的混合体。如果想要自己的思维更加接近成长型思维的话，应该做的绝不是将另一面隔离开来，
                            是去仔细观察自己的固定型思维是如何被触发的，唯有如此，我们才能真正开始成长型思维的旅程。
                          </p>
                          <p style="box-sizing: border-box;">
                            <br style="box-sizing: border-box;" />
                          </p>
                        </section>
                      </section>
                    </section>
                  </section>
                </section>
              </section>
            </section>
          </section>
          <section class style="box-sizing: border-box;" powered-by="xiumi.us">
            <section class style="   box-sizing: border-box; ">
              <section class style="box-sizing: border-box;">
                <p style="box-sizing: border-box;">
                  <br style="box-sizing: border-box;" />
                </p>
              </section>
            </section>
          </section>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "list4",
  data() {
    return {};
  },
  props: ["listOrCon"],
  methods:{
    returnFun(){
      this.$emit("returnPage")
    }
  }
};
</script>
<style scoped>
.rich_media_content {
  overflow: hidden;
  color: #333;
  font-size: 17px;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  text-align: justify;
  position: relative;
  z-index: 0;
}

.rich_media_content * {
  max-width: 100% !important;
  box-sizing: border-box !important;
  -webkit-box-sizing: border-box !important;
  word-wrap: break-word !important;
}

.rich_media_content p {
  clear: both;
  min-height: 1em;
}

.rich_media_content em {
  font-style: italic;
}

.rich_media_content img {
  height: auto !important;
}
.tab > div > span{
  cursor: pointer;
  display: inline-block;
  padding: 4px 10px;
  border-radius: 5px;
  color: #7ecef4;
  border: solid 1px #7ecef4
}
</style>


// WEBPACK FOOTER //
// src/components/growthThinking/list4.vue